export default (eventType, actType, path) => {
  return {
    event: eventType, // Dinamic Data
    actionType: actType, // Dynamic Data
    sectionName: path, // Dynamic Data
  };
};
